// Code generated by packages/app-routes/gen.ts. DO NOT EDIT.
// Source: packages/app-routes/routes.json
export const ROUTES = [
    {
        id: "dashboard",
        path: "/dashboard",
        title: "Home",
        opens: {
            page: "Dashboard"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the signed-in home dashboard."
    },
    {
        id: "growth.home",
        path: "/growth/home",
        title: "Growth home",
        opens: {
            page: "GrowthHome"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open the Growth-only landing page."
    },
    {
        id: "growth.rfi-responses",
        path: "/growth/rfi-responses",
        title: "RFI responses",
        opens: {
            page: "GrowthRfiResponses"
        },
        permission: {
            kind: "workflow_area",
            area: "capture"
        },
        purpose: "Open the Growth list of RFI-response workspaces."
    },
    {
        id: "growth.proposals",
        path: "/growth/proposals",
        title: "Proposals",
        opens: {
            page: "GrowthProposals"
        },
        permission: {
            kind: "workflow_area",
            area: "projects"
        },
        purpose: "Open the Growth list of proposal workspaces."
    },
    {
        id: "assistant",
        path: "/assistant",
        title: "Assistant",
        opens: {
            page: "Assistant"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the assist chat landing."
    },
    {
        id: "assistant.conversation",
        path: "/assistant/:id",
        title: "Assistant conversation",
        opens: {
            page: "Assistant"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one assist conversation."
    },
    {
        id: "artifact-studio",
        path: "/artifact-studio/:projectId",
        title: "Artifact Studio",
        opens: {
            page: "ArtifactStudio"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the project-scoped generate/edit/approve studio."
    },
    {
        id: "oci",
        path: "/oci/:projectId",
        title: "OCI workspace",
        opens: {
            page: "OciWorkspace"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the OCI workspace for a project."
    },
    {
        id: "protest",
        path: "/protest/:projectId",
        title: "Protest workspace",
        opens: {
            page: "ProtestWorkspace"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the protest workspace for a project."
    },
    {
        id: "settings",
        path: "/settings",
        title: "Settings",
        opens: {
            page: "Settings"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open account settings (profile by default).",
        builder: "Settings"
    },
    {
        id: "settings.profile",
        path: "/settings?section=profile",
        title: "Settings · Profile",
        opens: {
            page: "Settings",
            tab: "profile"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the profile section of Settings.",
        builder: "Settings"
    },
    {
        id: "settings.notifications",
        path: "/settings?section=notifications",
        title: "Settings · Notifications",
        opens: {
            page: "Settings",
            tab: "notifications"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open notification preferences.",
        builder: "Settings"
    },
    {
        id: "settings.history",
        path: "/settings?section=history",
        title: "Settings · History",
        opens: {
            page: "Settings",
            tab: "history"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the signed-in user's activity history.",
        builder: "Settings"
    },
    {
        id: "settings.sso",
        path: "/settings?section=sso",
        title: "Settings · Single Sign-On",
        opens: {
            page: "Settings",
            tab: "sso"
        },
        permission: {
            kind: "admin_or_it_admin"
        },
        purpose: "Open tenant sign-in (SSO) configuration.",
        builder: "Settings"
    },
    {
        id: "settings.authorization",
        path: "/settings?section=authorization",
        title: "Settings · Authorization Policies",
        opens: {
            page: "Settings",
            tab: "authorization"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open authorization policy configuration.",
        builder: "Settings"
    },
    {
        id: "settings.appearance",
        path: "/settings?section=appearance",
        title: "Settings · Appearance",
        opens: {
            page: "Settings",
            tab: "appearance"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open appearance preferences.",
        builder: "Settings"
    },
    {
        id: "settings.sharepoint",
        path: "/settings?section=sharepoint",
        title: "Settings · SharePoint",
        opens: {
            page: "Settings",
            tab: "sharepoint"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the viewer's SharePoint connection.",
        builder: "Settings"
    },
    {
        id: "settings.bug-reports",
        path: "/settings?section=bug-reports",
        title: "Settings · Bug Reports",
        opens: {
            page: "Settings",
            tab: "bug-reports"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the bug-report log.",
        builder: "Settings"
    },
    {
        id: "sso-config",
        path: "/sso-config",
        title: "SSO configuration",
        opens: {
            page: "SSOConfig"
        },
        permission: {
            kind: "admin_or_it_admin"
        },
        purpose: "Open the standalone SSO configuration page."
    },
    {
        id: "policy-config",
        path: "/policy-config",
        title: "Authorization policies",
        opens: {
            page: "PolicyConfig"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open the standalone authorization-policy page."
    },
    {
        id: "opportunities",
        path: "/opportunities",
        title: "Opportunities",
        opens: {
            page: "Opportunities"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open the opportunities list."
    },
    {
        id: "tracking-profiles",
        path: "/opportunities/tracking-profiles",
        title: "Tracking Profiles",
        opens: {
            page: "TrackingProfiles"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open saved opportunity tracking profiles."
    },
    {
        id: "tracking-profiles.create",
        path: "/opportunities/tracking-profiles/create",
        title: "Create tracking profile",
        opens: {
            page: "TrackingProfiles"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open the create-tracking-profile form."
    },
    {
        id: "tracking-profiles.detail",
        path: "/opportunities/tracking-profiles/:id",
        title: "Tracking profile",
        opens: {
            page: "TrackingProfiles"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open one tracking profile and its matches."
    },
    {
        id: "tracking-profiles.edit",
        path: "/opportunities/tracking-profiles/:id/edit",
        title: "Edit tracking profile",
        opens: {
            page: "TrackingProfiles"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Edit one tracking profile's criteria."
    },
    {
        id: "landscapes",
        path: "/landscapes",
        title: "Landscapes",
        opens: {
            page: "Landscapes"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open the landscapes list."
    },
    {
        id: "landscapes.new",
        path: "/landscapes/new",
        title: "New landscape",
        opens: {
            page: "LandscapeForm"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Create a landscape."
    },
    {
        id: "landscapes.detail",
        path: "/landscapes/:id",
        title: "Landscape",
        opens: {
            page: "LandscapeDetail"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open one landscape."
    },
    {
        id: "landscapes.seats",
        path: "/landscapes/:id/seats",
        title: "Landscape · seat history",
        opens: {
            page: "LandscapeSeats"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open one landscape's seat history."
    },
    {
        id: "landscapes.edit",
        path: "/landscapes/:id/edit",
        title: "Edit landscape",
        opens: {
            page: "LandscapeForm"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Edit one landscape."
    },
    {
        id: "landscapes.reports",
        path: "/landscapes/:id/briefs",
        title: "Review briefs",
        opens: {
            page: "LandscapeReports"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Generate and browse a landscape's point-in-time review briefs."
    },
    {
        id: "landscapes.reports.detail",
        path: "/landscapes/:id/briefs/:reportId",
        title: "Review brief",
        opens: {
            page: "LandscapeReport"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open one frozen landscape review brief version."
    },
    {
        id: "capture",
        path: "/capture",
        title: "Pursuits",
        opens: {
            page: "CaptureList"
        },
        permission: {
            kind: "workflow_area",
            area: "capture"
        },
        purpose: "Open the pursuits list."
    },
    {
        id: "capture.detail",
        path: "/capture/:id",
        title: "Pursuit",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one pursuit (Growth on that record, not the list).",
        builder: "CaptureDetail"
    },
    {
        id: "capture.overview",
        path: "/capture/:id?tab=overview",
        title: "Pursuit · Overview",
        opens: {
            page: "CaptureDetail",
            tab: "overview"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's overview tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.rfis",
        path: "/capture/:id?tab=rfis",
        title: "Pursuit · RFIs",
        opens: {
            page: "CaptureDetail",
            tab: "rfis"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's RFIs tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.interactions",
        path: "/capture/:id?tab=interactions",
        title: "Pursuit · Interactions",
        opens: {
            page: "CaptureDetail",
            tab: "interactions"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's interactions tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.themes",
        path: "/capture/:id?tab=themes",
        title: "Pursuit · Themes",
        opens: {
            page: "CaptureDetail",
            tab: "themes"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's customer-themes tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.workstreams",
        path: "/capture/:id?tab=workstreams",
        title: "Pursuit · Workstreams",
        opens: {
            page: "CaptureDetail",
            tab: "workstreams"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's workstreams tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.documents",
        path: "/capture/:id?tab=documents",
        title: "Pursuit · Documents",
        opens: {
            page: "CaptureDetail",
            tab: "documents"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's documents tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.past-performance",
        path: "/capture/:id?tab=past-performance",
        title: "Pursuit · Past performance",
        opens: {
            page: "CaptureDetail",
            tab: "past-performance"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's past-performance tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.solution",
        path: "/capture/:id?tab=solution",
        title: "Pursuit · Solution",
        opens: {
            page: "CaptureDetail",
            tab: "solution"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's solution tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.outputs",
        path: "/capture/:id?tab=outputs",
        title: "Pursuit · Outputs",
        opens: {
            page: "CaptureDetail",
            tab: "outputs"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's outputs tab.",
        builder: "CaptureDetail"
    },
    {
        id: "capture.customer",
        path: "/capture/:id/customer",
        title: "Pursuit · Customer & touchpoints",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's Customer & touchpoints section (touchpoints and people)."
    },
    {
        id: "capture.customer-themes",
        path: "/capture/:id/customer/themes",
        title: "Pursuit · Customer themes",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's customer themes."
    },
    {
        id: "capture.competitors",
        path: "/capture/:id/competitors",
        title: "Pursuit · Competitors",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's competitive field."
    },
    {
        id: "capture.black-hat",
        path: "/capture/:id/black-hat",
        title: "Pursuit · Black hat",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's black hat."
    },
    {
        id: "capture.win-themes",
        path: "/capture/:id/win-themes",
        title: "Pursuit · Win themes",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's win themes."
    },
    {
        id: "capture.teaming",
        path: "/capture/:id/teaming",
        title: "Pursuit · Teaming",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's teaming links, candidates and agreements."
    },
    {
        id: "capture.rfi-responses",
        path: "/capture/:id/rfi-responses",
        title: "Pursuit · RFI responses",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's RFI response workspaces."
    },
    {
        id: "capture.proposal",
        path: "/capture/:id/proposal",
        title: "Pursuit · Proposal",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the proposals opened from a pursuit."
    },
    {
        id: "capture.decisions",
        path: "/capture/:id/decisions",
        title: "Pursuit · Go / no-go",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's gates, go/no-go decisions and lifecycle."
    },
    {
        id: "capture.surgery",
        path: "/capture/:id/surgery",
        title: "Pursuit · Splits & merges",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's splits and merges."
    },
    {
        id: "capture.documents-section",
        path: "/capture/:id/documents",
        title: "Pursuit · Docs",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's documents section."
    },
    {
        id: "capture.plan",
        path: "/capture/:id/plan",
        title: "Pursuit · Profile & plan",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's hypothesis, profile, team and action plan."
    },
    {
        id: "capture.solution-section",
        path: "/capture/:id/solution",
        title: "Pursuit · Solution",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's solution section."
    },
    {
        id: "capture.outputs-section",
        path: "/capture/:id/outputs",
        title: "Pursuit · Outputs",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's outputs section."
    },
    {
        id: "capture.past-performance-section",
        path: "/capture/:id/past-performance",
        title: "Pursuit · Past performance",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's past performance section."
    },
    {
        id: "capture.workstreams-section",
        path: "/capture/:id/workstreams",
        title: "Pursuit · Workstreams",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's workstreams section."
    },
    {
        id: "capture.graph",
        path: "/capture/:id/graph",
        title: "Pursuit · Knowledge graph",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the knowledge graph from a pursuit."
    },
    {
        id: "capture.chat",
        path: "/capture/:id/chat",
        title: "Pursuit · Chat",
        opens: {
            page: "CaptureDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a pursuit's chat."
    },
    {
        id: "rfi-response",
        path: "/rfi-response/:id",
        title: "RFI response",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI response workspace."
    },
    {
        id: "rfi-response.document",
        path: "/rfi-response/:id/document",
        title: "RFI response · Response document",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's response document at the top."
    },
    {
        id: "rfi-response.questions",
        path: "/rfi-response/:id/questions",
        title: "RFI response · Questions",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's first question in the response document."
    },
    {
        id: "rfi-response.questions-question",
        path: "/rfi-response/:id/questions/:sectionId",
        title: "RFI response · Question",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the RFI response document at one question's heading (sectionId = rfi_response_sections.id)."
    },
    {
        id: "rfi-response.capability-statement",
        path: "/rfi-response/:id/capability-statement",
        title: "RFI response · Capability statement",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's capability statement."
    },
    {
        id: "rfi-response.reviews",
        path: "/rfi-response/:id/reviews",
        title: "RFI response · Reviews",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's reviews."
    },
    {
        id: "rfi-response.chat",
        path: "/rfi-response/:id/chat",
        title: "RFI response · Chat history",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's chat history."
    },
    {
        id: "rfi-response.notice",
        path: "/rfi-response/:id/notice",
        title: "RFI response · Notice and attachments",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's notice and attachments."
    },
    {
        id: "rfi-response.labor-categories",
        path: "/rfi-response/:id/labor-categories",
        title: "RFI response · Labor categories",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's labor categories."
    },
    {
        id: "rfi-response.amendments",
        path: "/rfi-response/:id/amendments",
        title: "RFI response · Q&A and amendments",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's Q&A and amendments."
    },
    {
        id: "rfi-response.past-answers",
        path: "/rfi-response/:id/past-answers",
        title: "RFI response · Past answers",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open past answers relevant to an RFI."
    },
    {
        id: "rfi-response.team",
        path: "/rfi-response/:id/team",
        title: "RFI response · Team",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an RFI's team."
    },
    {
        id: "rfi-response.legacy",
        path: "/rfi-response/:id/legacy",
        title: "RFI response · Per-question editor",
        opens: {
            page: "RfiResponse"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the legacy per-question RFI workspace."
    },
    {
        id: "registries",
        path: "/registries",
        title: "Registries",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open tenant-wide registries (companies tab by default).",
        builder: "Registries"
    },
    {
        id: "registries.companies",
        path: "/registries?tab=companies",
        title: "Registries · Companies",
        opens: {
            page: "Registries",
            tab: "companies"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the companies registry.",
        builder: "Registries"
    },
    {
        id: "registries.contacts",
        path: "/registries?tab=contacts",
        title: "Registries · Contacts",
        opens: {
            page: "Registries",
            tab: "contacts"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the contacts registry.",
        builder: "Registries"
    },
    {
        id: "registries.contracts",
        path: "/registries?tab=contracts",
        title: "Registries · Contracts",
        opens: {
            page: "Registries",
            tab: "contracts"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the contracts registry.",
        builder: "Registries"
    },
    {
        id: "registries.govorgs",
        path: "/registries?tab=govorgs",
        title: "Registries · Government orgs",
        opens: {
            page: "Registries",
            tab: "govorgs"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the government-organizations registry.",
        builder: "Registries"
    },
    {
        id: "registries.capabilities",
        path: "/registries?tab=capabilities",
        title: "Registries · Capabilities",
        opens: {
            page: "Registries",
            tab: "capabilities"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the capabilities registry.",
        builder: "Registries"
    },
    {
        id: "registries.vehicles",
        path: "/registries?tab=vehicles",
        title: "Registries · Vehicles",
        opens: {
            page: "Registries",
            tab: "vehicles"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the contract-vehicles registry.",
        builder: "Registries"
    },
    {
        id: "registries.lcats",
        path: "/registries?tab=lcats",
        title: "Registries · Labor categories",
        opens: {
            page: "Registries",
            tab: "lcats"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the labor-categories registry.",
        builder: "Registries"
    },
    {
        id: "registries.rate-book",
        path: "/registries?tab=rate-book",
        title: "Registries · Rate book",
        opens: {
            page: "Registries",
            tab: "rate-book"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the rate-book registry.",
        builder: "Registries"
    },
    {
        id: "registries.roles",
        path: "/registries?tab=roles",
        title: "Registries · Role types",
        opens: {
            page: "Registries",
            tab: "roles"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the program role-types registry.",
        builder: "Registries"
    },
    {
        id: "registries.pricing-sheets",
        path: "/registries?tab=pricing-sheets",
        title: "Registries · Pricing sheets",
        opens: {
            page: "Registries",
            tab: "pricing-sheets"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the pricing-sheets registry.",
        builder: "Registries"
    },
    {
        id: "registries.pricing-sheet-review",
        path: "/registries/pricing-sheets/:changeSetId",
        title: "Pricing sheet review",
        opens: {
            page: "PricingSheetReview"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Review one staged pricing sheet."
    },
    {
        id: "registries.contact",
        path: "/registries/contacts/:id",
        title: "Contact",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one person's full registry record (flag registries_records_v1; off opens the drawer)."
    },
    {
        id: "registries.company",
        path: "/registries/companies/:id",
        title: "Company",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one company's full registry record (flag registries_records_v1; off opens the drawer)."
    },
    {
        id: "registries.lcat-anchor",
        path: "/registries/labor-categories/:anchorId",
        title: "Labor category",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one labor category anchor across companies (flag registries_records_v1)."
    },
    {
        id: "registries.lcat-entry",
        path: "/registries/labor-categories/entries/:entryId",
        title: "Labor category entry",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one company's labor category entry as a full page (flag registries_records_v1)."
    },
    {
        id: "registries.vehicle",
        path: "/registries/vehicles/:id",
        title: "Contract vehicle",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one contract vehicle's full registry record (flag registries_records_v1)."
    },
    {
        id: "registries.govorg",
        path: "/registries/gov-orgs/:id",
        title: "Government org",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one government organization's full registry record (flag registries_records_v1)."
    },
    {
        id: "registries.review-queue",
        path: "/registries/review-queue",
        title: "Review queue",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the unified registry review queue (flag registries_records_v1)."
    },
    {
        id: "registries.people-movement",
        path: "/registries/people-movement",
        title: "People movement",
        opens: {
            page: "Registries"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open people movement: org charts over time and moves between organizations (flags registries_records_v1 + people_movement_v1)."
    },
    {
        id: "delivery",
        path: "/delivery",
        title: "Delivery",
        opens: {
            page: "DeliveryOverview"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the delivery hub."
    },
    {
        id: "delivery.command-center",
        path: "/delivery/command-center",
        title: "Command Center",
        opens: {
            page: "CommandCenter"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the cross-project delivery command center."
    },
    {
        id: "delivery.command-center.deliverables",
        path: "/delivery/command-center/deliverables",
        title: "Command Center · Deliverables",
        opens: {
            page: "CommandCenterDeliverables"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the command-center deliverables drill-down."
    },
    {
        id: "delivery.org",
        path: "/delivery/org",
        title: "Organization",
        opens: {
            page: "DeliveryOrg"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the delivery organization view."
    },
    {
        id: "delivery.evidence-board",
        path: "/delivery/evidence-board",
        title: "Proof & Evidence Board",
        opens: {
            page: "EvidenceBoard"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the cross-portfolio evidence board."
    },
    {
        id: "delivery.calendar",
        path: "/delivery/calendar",
        title: "Delivery Calendar",
        opens: {
            page: "DeliveryCalendar"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the cross-project delivery calendar."
    },
    {
        id: "delivery.programs",
        path: "/delivery/programs",
        title: "Programs",
        opens: {
            page: "ProgramsList"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the programs list."
    },
    {
        id: "delivery.audit-templates",
        path: "/delivery/audit-templates",
        title: "Audit templates",
        opens: {
            page: "AuditTemplates"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open delivery audit templates."
    },
    {
        id: "delivery.pre-award",
        path: "/delivery/pre-award/:id/v2",
        title: "Pre-award workspace",
        opens: {
            page: "PreAwardWorkspace"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the pre-award V2 cockpit."
    },
    {
        id: "delivery.award-comparison",
        path: "/delivery/pre-award/:id/comparison/:csId",
        title: "Award comparison",
        opens: {
            page: "AwardComparison"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open an award-comparison workspace."
    },
    {
        id: "program.home",
        path: "/delivery/programs/:programId",
        title: "Program home",
        opens: {
            page: "ProgramHome"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's home."
    },
    {
        id: "program.activation-gate",
        path: "/delivery/programs/:programId/activation-gate",
        title: "Activation Gate",
        opens: {
            page: "ActivationGate"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a converted program's activation gate."
    },
    {
        id: "program.closeout",
        path: "/delivery/programs/:programId/closeout",
        title: "Closeout",
        opens: {
            page: "Closeout"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's closeout page."
    },
    {
        id: "program.workroom",
        path: "/delivery/programs/:programId/workroom",
        title: "Workroom",
        opens: {
            page: "Workroom"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's workroom."
    },
    {
        id: "program.roles",
        path: "/delivery/programs/:programId/roles",
        title: "Roles",
        opens: {
            page: "Roles"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's roles page."
    },
    {
        id: "program.companies",
        path: "/delivery/programs/:programId/companies",
        title: "Companies",
        opens: {
            page: "Companies"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's companies page.",
        builder: "ProgramCompanies"
    },
    {
        id: "program.companies.company",
        path: "/delivery/programs/:programId/companies?company=:companyProfileId",
        title: "Companies · Company",
        opens: {
            page: "Companies"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's companies page on one company's details.",
        builder: "ProgramCompanies"
    },
    {
        id: "program.contacts",
        path: "/delivery/programs/:programId/contacts",
        title: "Contacts",
        opens: {
            page: "Contacts"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's contacts page."
    },
    {
        id: "program.clins",
        path: "/delivery/programs/:programId/clins",
        title: "CLINs",
        opens: {
            page: "CLINs"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's CLIN table."
    },
    {
        id: "program.teams",
        path: "/delivery/programs/:programId/workstreams",
        title: "Teams",
        opens: {
            page: "Teams"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's teams index."
    },
    {
        id: "program.team",
        path: "/delivery/programs/:programId/workstreams/:wsId",
        title: "Team",
        opens: {
            page: "Team"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open one team (deliverables tab by default).",
        builder: "ProgramTeam"
    },
    {
        id: "program.team.work",
        path: "/delivery/programs/:programId/workstreams/:wsId?tab=work",
        title: "Team · Work products",
        opens: {
            page: "Team",
            tab: "work"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a team's work-products tab.",
        builder: "ProgramTeam"
    },
    {
        id: "program.team.members",
        path: "/delivery/programs/:programId/workstreams/:wsId?tab=members",
        title: "Team · Members",
        opens: {
            page: "Team",
            tab: "members"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a team's members tab.",
        builder: "ProgramTeam"
    },
    {
        id: "program.capabilities",
        path: "/delivery/programs/:programId/capabilities",
        title: "Capabilities",
        opens: {
            page: "Capabilities"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's capabilities page."
    },
    {
        id: "program.deliverables",
        path: "/delivery/programs/:programId/deliverables",
        title: "Deliverables",
        opens: {
            page: "Deliverables"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's deliverables page.",
        builder: "ProgramDeliverables"
    },
    {
        id: "program.deliverables.occurrence",
        path: "/delivery/programs/:programId/deliverables?occ=:occurrenceId",
        title: "Deliverables · Occurrence",
        opens: {
            page: "Deliverables",
            drawer: "occurrence"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the occurrence drawer on Deliverables.",
        builder: "ProgramDeliverables"
    },
    {
        id: "program.deliverables.submit",
        path: "/delivery/programs/:programId/deliverables?submit=:occurrenceId",
        title: "Deliverables · Submit",
        opens: {
            page: "Deliverables",
            drawer: "submit"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the submit drawer on Deliverables.",
        builder: "ProgramDeliverables"
    },
    {
        id: "program.deliverables.review",
        path: "/delivery/programs/:programId/deliverables?review=:submissionId",
        title: "Deliverables · Record review",
        opens: {
            page: "Deliverables",
            drawer: "review"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the record-review drawer on Deliverables.",
        builder: "ProgramDeliverables"
    },
    {
        id: "program.deliverables.assign",
        path: "/delivery/programs/:programId/deliverables?assign=:assignRef",
        title: "Deliverables · Assignment",
        opens: {
            page: "Deliverables",
            drawer: "assign"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the assignment drawer on Deliverables.",
        builder: "ProgramDeliverables"
    },
    {
        id: "program.deliverable",
        path: "/delivery/programs/:programId/deliverables/:dutyId",
        title: "Deliverable",
        opens: {
            page: "Deliverable"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open one deliverable (duty) page."
    },
    {
        id: "program.beyond-scope",
        path: "/delivery/programs/:programId/beyond-scope",
        title: "Beyond Scope",
        opens: {
            page: "BeyondScope"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open work beyond the award."
    },
    {
        id: "program.weekly-recap",
        path: "/delivery/programs/:programId/weekly-recap",
        title: "Weekly Recap",
        opens: {
            page: "WeeklyRecap"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's weekly recap."
    },
    {
        id: "program.optional-tasks",
        path: "/delivery/programs/:programId/optional-tasks",
        title: "Optional Tasks",
        opens: {
            page: "OptionalTasks"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's optional tasks."
    },
    {
        id: "program.places",
        path: "/delivery/programs/:programId/places",
        title: "Places",
        opens: {
            page: "Places"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's places page."
    },
    {
        id: "program.glossary",
        path: "/delivery/programs/:programId/glossary",
        title: "Glossary",
        opens: {
            page: "Glossary"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's glossary."
    },
    {
        id: "program.periods",
        path: "/delivery/programs/:programId/periods",
        title: "Periods",
        opens: {
            page: "Periods"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's periods of performance."
    },
    {
        id: "program.settings",
        path: "/delivery/programs/:programId/settings",
        title: "Program settings",
        opens: {
            page: "ProgramSettings"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's deliverable settings."
    },
    {
        id: "program.audits",
        path: "/delivery/programs/:programId/audits",
        title: "Audits",
        opens: {
            page: "Audits"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's audits page."
    },
    {
        id: "program.waivers-tailoring",
        path: "/delivery/programs/:programId/waivers-tailoring",
        title: "Waivers and Tailoring",
        opens: {
            page: "WaiversTailoring"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open waivers and tailoring."
    },
    {
        id: "program.quality",
        path: "/delivery/programs/:programId/quality",
        title: "Quality",
        opens: {
            page: "Quality"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's quality page."
    },
    {
        id: "program.potential-issues",
        path: "/delivery/programs/:programId/potential-issues",
        title: "Potential Issues",
        opens: {
            page: "PotentialIssues"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open potential issues (risks tab by default)."
    },
    {
        id: "program.potential-issues.risks",
        path: "/delivery/programs/:programId/potential-issues?tab=risks",
        title: "Potential Issues · Risks",
        opens: {
            page: "PotentialIssues",
            tab: "risks"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the risks sub-tab."
    },
    {
        id: "program.potential-issues.issues",
        path: "/delivery/programs/:programId/potential-issues?tab=issues",
        title: "Potential Issues · Issues",
        opens: {
            page: "PotentialIssues",
            tab: "issues"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the issues sub-tab."
    },
    {
        id: "program.potential-issues.sub-reviews",
        path: "/delivery/programs/:programId/potential-issues?tab=sub-reviews",
        title: "Potential Issues · Sub reviews",
        opens: {
            page: "PotentialIssues",
            tab: "sub-reviews"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the subcontractor-reviews sub-tab."
    },
    {
        id: "program.history",
        path: "/delivery/programs/:programId/ops-audit",
        title: "History",
        opens: {
            page: "ProgramHistory"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's operations history (ops-audit)."
    },
    {
        id: "program.touchpoints",
        path: "/delivery/programs/:programId/touchpoints",
        title: "Touchpoints",
        opens: {
            page: "Touchpoints"
        },
        permission: {
            kind: "program_area",
            area: "area:growth"
        },
        purpose: "Open a program's growth touchpoints."
    },
    {
        id: "program.financial",
        path: "/delivery/programs/:programId/financial",
        title: "Financial",
        opens: {
            page: "Financial"
        },
        permission: {
            kind: "program_financial"
        },
        purpose: "Open financial health when at least one figure is unmasked."
    },
    {
        id: "program.docs",
        path: "/delivery/programs/:programId/docs",
        title: "Docs",
        opens: {
            page: "Docs"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open a program's documents (documents tab by default).",
        builder: "ProgramDocs"
    },
    {
        id: "program.docs.documents",
        path: "/delivery/programs/:programId/docs?tab=documents",
        title: "Docs · Documents",
        opens: {
            page: "Docs",
            tab: "documents"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the documents sub-tab.",
        builder: "ProgramDocs"
    },
    {
        id: "program.docs.modifications",
        path: "/delivery/programs/:programId/docs?tab=modifications",
        title: "Docs · Modifications",
        opens: {
            page: "Docs",
            tab: "modifications"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the modifications sub-tab.",
        builder: "ProgramDocs"
    },
    {
        id: "program.docs.modifications.set",
        path: "/delivery/programs/:programId/docs?tab=modifications&set=:changeSetId",
        title: "Docs · Modification set",
        opens: {
            page: "Docs",
            tab: "modifications"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open one modification change set.",
        builder: "ProgramDocs"
    },
    {
        id: "program.docs.modifications.item",
        path: "/delivery/programs/:programId/docs?tab=modifications&set=:changeSetId&item=:itemId",
        title: "Docs · Modification item",
        opens: {
            page: "Docs",
            tab: "modifications"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open one modification change item.",
        builder: "ProgramDocs"
    },
    {
        id: "program.docs.lineage",
        path: "/delivery/programs/:programId/docs?tab=lineage",
        title: "Docs · Lineage",
        opens: {
            page: "Docs",
            tab: "lineage"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open the document lineage sub-tab.",
        builder: "ProgramDocs"
    },
    {
        id: "program.docs.doc",
        path: "/delivery/programs/:programId/docs?doc=:docId",
        title: "Docs · Document",
        opens: {
            page: "Docs"
        },
        permission: {
            kind: "program_read"
        },
        purpose: "Open Docs focused on one document id.",
        builder: "ProgramDocs"
    },
    {
        id: "documents",
        path: "/documents",
        title: "Documents",
        opens: {
            page: "Documents"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the global documents library."
    },
    {
        id: "documents.upload",
        path: "/documents/upload",
        title: "Upload document",
        opens: {
            page: "DocumentUpload"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the global document upload page."
    },
    {
        id: "editor",
        path: "/editor",
        title: "Editor",
        opens: {
            page: "EditorList"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the collaborative editor list."
    },
    {
        id: "editor.folder",
        path: "/editor/folder/:folderId",
        title: "Editor folder",
        opens: {
            page: "EditorList"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one editor folder."
    },
    {
        id: "editor.document",
        path: "/editor/:documentId",
        title: "Editor document",
        opens: {
            page: "EditorPage"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one collaborative document."
    },
    {
        id: "sharepoint-documents",
        path: "/sharepoint-documents",
        title: "SharePoint documents",
        opens: {
            page: "SharePointDocuments"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the SharePoint documents browser."
    },
    {
        id: "projects",
        path: "/projects",
        title: "Projects",
        opens: {
            page: "ProjectList"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the projects list."
    },
    {
        id: "projects.create",
        path: "/projects/create",
        title: "Create project",
        opens: {
            page: "CreateProject"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the create-project wizard."
    },
    {
        id: "project.overview",
        path: "/project/:projectId",
        title: "Project",
        opens: {
            page: "ProjectOverview"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a general project's overview."
    },
    {
        id: "project.chat",
        path: "/project/:projectId/chat",
        title: "Project chat",
        opens: {
            page: "ProjectChatList"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a project's chat list."
    },
    {
        id: "project.chat.conversation",
        path: "/project/:projectId/chat/:chatId",
        title: "Project conversation",
        opens: {
            page: "ProjectChatView"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one project conversation."
    },
    {
        id: "project.documents",
        path: "/project/:projectId/documents",
        title: "Project documents",
        opens: {
            page: "ProjectDocuments"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a project's documents."
    },
    {
        id: "project.team",
        path: "/project/:projectId/team",
        title: "Project team",
        opens: {
            page: "ProjectTeam"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a project's team page."
    },
    {
        id: "project.settings",
        path: "/project/:projectId/settings",
        title: "Project settings",
        opens: {
            page: "ProjectSettings"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a project's settings."
    },
    {
        id: "project.opportunities",
        path: "/project/:projectId/opportunities",
        title: "Project opportunities",
        opens: {
            page: "Opportunities"
        },
        permission: {
            kind: "workflow_area",
            area: "opportunities"
        },
        purpose: "Open opportunities while staying in a project."
    },
    {
        id: "project.sharepoint",
        path: "/project/:projectId/sharepoint",
        title: "Project SharePoint",
        opens: {
            page: "SharePointDocuments"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open SharePoint documents in project context."
    },
    {
        id: "project.history",
        path: "/project/:projectId/history",
        title: "Project history",
        opens: {
            page: "History"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open history in project context."
    },
    {
        id: "proposal",
        path: "/proposal/:id",
        title: "Proposal",
        opens: {
            page: "ProposalDashboardV2"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a proposal dashboard."
    },
    {
        id: "proposal.settings",
        path: "/proposal/:id/settings",
        title: "Proposal settings",
        opens: {
            page: "ProjectSettings"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open a proposal's settings."
    },
    {
        id: "proposal.v2.home",
        path: "/proposal/:id/v2/home",
        title: "Proposal V2 · Home",
        opens: {
            page: "ProposalDashboardV2",
            tab: "home"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the V2 proposal home."
    },
    {
        id: "proposal.v2.compliance",
        path: "/proposal/:id/v2/compliance",
        title: "Proposal V2 · Compliance",
        opens: {
            page: "ProposalDashboardV2",
            tab: "compliance"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the V2 compliance hub."
    },
    {
        id: "proposal.v2.capability-matrix",
        path: "/proposal/:id/v2/capability-matrix",
        title: "Proposal V2 · Capability matrix",
        opens: {
            page: "ProposalDashboardV2",
            tab: "capability-matrix"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the V2 capability matrix."
    },
    {
        id: "proposal.v2.reviews",
        path: "/proposal/:id/v2/reviews",
        title: "Proposal V2 · Reviews",
        opens: {
            page: "ProposalDashboardV2",
            tab: "reviews"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the V2 reviews list."
    },
    {
        id: "proposal.v2.review",
        path: "/proposal/:id/v2/reviews/:reviewId",
        title: "Proposal V2 · Review",
        opens: {
            page: "ProposalReviewDetail"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one V2 proposal review."
    },
    {
        id: "proposal.v2.chat-history",
        path: "/proposal/:id/v2/chat-history",
        title: "Proposal V2 · Chat history",
        opens: {
            page: "ProposalDashboardV2",
            tab: "chat-history"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the V2 proposal chat history."
    },
    {
        id: "proposal.v2.volume",
        path: "/proposal/:id/v2/volume/:volumeId",
        title: "Proposal V2 · Volume",
        opens: {
            page: "VolumeWorkspace"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one proposal volume workspace."
    },
    {
        id: "proposal.v2.volume.section",
        path: "/proposal/:id/v2/volume/:volumeId/section/:sectionId",
        title: "Proposal V2 · Volume section",
        opens: {
            page: "VolumeWorkspace"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open one section inside a proposal volume."
    },
    {
        id: "proposal.v2.sources.files",
        path: "/proposal/:id/v2/sources/files",
        title: "Proposal V2 · Source files",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-files"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open V2 source files."
    },
    {
        id: "proposal.v2.sources.clins",
        path: "/proposal/:id/v2/sources/clins",
        title: "Proposal V2 · Source CLINs",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-clins"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open V2 source CLINs."
    },
    {
        id: "proposal.v2.sources.lcats",
        path: "/proposal/:id/v2/sources/lcats",
        title: "Proposal V2 · Source LCATs",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-lcats"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open V2 source labor categories."
    },
    {
        id: "proposal.v2.sources.pricing",
        path: "/proposal/:id/v2/sources/pricing",
        title: "Proposal V2 · Source pricing",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-pricing"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open V2 source pricing."
    },
    {
        id: "proposal.v2.sources.pursuit",
        path: "/proposal/:id/v2/sources/pursuit",
        title: "Proposal V2 · From the pursuit",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-pursuit"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open what the proposal carried in from its pursuit."
    },
    {
        id: "proposal.v2.sources.team",
        path: "/proposal/:id/v2/sources/team",
        title: "Proposal V2 · Source team",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-team"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open V2 source team."
    },
    {
        id: "proposal.v2.sources.history",
        path: "/proposal/:id/v2/sources/history",
        title: "Proposal V2 · Source history",
        opens: {
            page: "ProposalDashboardV2",
            tab: "sources-history"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open V2 source history."
    },
    {
        id: "requests",
        path: "/requests",
        title: "Access requests",
        opens: {
            page: "ReviewerRequests"
        },
        permission: {
            kind: "reviewer"
        },
        purpose: "Open the designated-grantor request queue."
    },
    {
        id: "admin.people",
        path: "/admin/people",
        title: "Admin · People",
        opens: {
            page: "AdminPeople"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open the admin people directory."
    },
    {
        id: "admin.groups",
        path: "/admin/groups",
        title: "Admin · Groups",
        opens: {
            page: "AdminGroups"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open admin groups."
    },
    {
        id: "admin.permissions",
        path: "/admin/permissions",
        title: "Admin · Permissions",
        opens: {
            page: "AdminPermissions"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open admin permissions."
    },
    {
        id: "admin.access-rules",
        path: "/admin/access-rules",
        title: "Admin · Access rules",
        opens: {
            page: "AdminAccessRules"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open admin access rules (who can see or do each sensitive thing)."
    },
    {
        id: "admin.activity",
        path: "/admin/activity",
        title: "Admin · Activity",
        opens: {
            page: "AdminActivity"
        },
        permission: {
            kind: "admin"
        },
        purpose: "Open the admin activity log."
    },
    {
        id: "admin.notifications",
        path: "/admin/notifications",
        title: "Admin · Notifications",
        opens: {
            page: "AdminNotifications"
        },
        permission: {
            kind: "admin_or_company_settings"
        },
        purpose: "Open company notification defaults and the delivery log."
    },
    {
        id: "admin.access",
        path: "/admin/access",
        title: "Admin · Access",
        opens: {
            page: "AdminAccess"
        },
        permission: {
            kind: "reviewer"
        },
        purpose: "Open access administration (server reviewer flag; self-service for others)."
    },
    {
        id: "admin.usage",
        path: "/admin/usage",
        title: "Admin · Usage",
        opens: {
            page: "AdminUsage"
        },
        permission: {
            kind: "admin_or_company_settings"
        },
        purpose: "Open admin usage."
    },
    {
        id: "help",
        path: "/help",
        title: "Help",
        opens: {
            page: "Help"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open help."
    },
    {
        id: "history",
        path: "/history",
        title: "History",
        opens: {
            page: "History"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the global history page."
    },
    {
        id: "library",
        path: "/library",
        title: "Library",
        opens: {
            page: "Library"
        },
        permission: {
            kind: "workflow_area",
            area: "library"
        },
        purpose: "Open the library."
    },
    {
        id: "vault",
        path: "/vault",
        title: "Vault",
        opens: {
            page: "Vault"
        },
        permission: {
            kind: "authenticated"
        },
        purpose: "Open the vault."
    }
];
export const EXCLUSIONS = [
    {
        path: "/login",
        reason: "Public sign-in page; chat does not deep-link to authentication."
    },
    {
        path: "/sign-in/access",
        reason: "Public sign-in dead-end page reached by an SSO redirect; chat does not deep-link to authentication."
    },
    {
        path: "/register",
        reason: "Public registration page; chat does not deep-link to authentication."
    },
    {
        path: "/set-password",
        reason: "Public invite-email landing (SAD-953); not an in-app destination."
    },
    {
        path: "/email-preferences",
        reason: "Public notification-email landing (SAD-954); not an in-app destination."
    },
    {
        path: "/auth/callback",
        reason: "OAuth callback; not a user-facing page."
    },
    {
        path: "/shared/:token",
        reason: "Public shared-link landing; chat already sits inside an authenticated session."
    },
    {
        path: "/",
        reason: "DefaultHome redirect; chat should send the viewer to /dashboard or /growth/home."
    },
    {
        path: "/growth",
        reason: "Growth hub is admitted by capture OR opportunities, which a single workflow_area permission cannot express; chat links the cards' targets (/capture, /opportunities) directly."
    },
    {
        path: "/research-assistant",
        reason: "Legacy alias that redirects to /assistant."
    },
    {
        path: "/tracking-profiles/*",
        reason: "Legacy alias that redirects into /opportunities/tracking-profiles."
    },
    {
        path: "/delivery/registries",
        reason: "Legacy alias that redirects to root-level /registries."
    },
    {
        path: "/delivery/programs/:id/v2",
        reason: "Retired ContractWorkspaceV2; redirects to program home or Docs → Modifications."
    },
    {
        path: "/delivery/programs/:id/tasks",
        reason: "Retired Tasks page; redirects to Deliverables."
    },
    {
        path: "/delivery/programs/:id/deliverable-lookahead",
        reason: "Retired Next 14 Days page; redirects to Deliverables."
    },
    {
        path: "/delivery/programs/:id/deviations",
        reason: "Pre-rename alias; redirects to /waivers-tailoring."
    },
    {
        path: "/delivery/programs/:id/risk",
        reason: "Pre-rename alias; redirects to /potential-issues."
    },
    {
        path: "/delivery/pre-award/:id",
        reason: "Retired V1 pre-award page; redirects to the V2 cockpit."
    },
    {
        path: "/delivery/audits/:id",
        reason: "Legacy flat audit URL; opens the audit panel on the program's Audits page."
    },
    {
        path: "/proposal",
        reason: "Bare /proposal has no landing; redirects to /projects."
    },
    {
        path: "/proposal/:id/v2",
        reason: "V2 shell index redirects to /v2/home."
    },
    {
        path: "/proposal/:id/v2/volume",
        reason: "Volume index redirects to V2 home so a breadcrumb click does not 404."
    },
    {
        path: "/proposal/:id/v2/sources",
        reason: "Sources index redirects to /sources/files."
    },
    {
        path: "/proposal/:id/v2/sources/:sourceKey",
        reason: "Catch-all placeholder for unknown source keys; known keys have explicit catalog entries."
    },
    {
        path: "/admin",
        reason: "Admin index redirects to /admin/people."
    },
    {
        path: "/contract/:id",
        reason: "Retired contract workspace; redirects to the general project."
    }
];
export const BUILDERS = [
    {
        name: "ProgramDocs",
        path: "/delivery/programs/:programId/docs",
        query: [
            "tab",
            "set",
            "item",
            "doc"
        ]
    },
    {
        name: "ProgramCompanies",
        path: "/delivery/programs/:programId/companies",
        query: [
            "company"
        ]
    },
    {
        name: "ProgramDeliverables",
        path: "/delivery/programs/:programId/deliverables",
        query: [
            "occ",
            "submit",
            "review",
            "assign"
        ]
    },
    {
        name: "ProgramTeam",
        path: "/delivery/programs/:programId/workstreams/:wsId",
        query: [
            "tab"
        ]
    },
    {
        name: "Registries",
        path: "/registries",
        query: [
            "tab",
            "record"
        ]
    },
    {
        name: "Settings",
        path: "/settings",
        query: [
            "section"
        ]
    },
    {
        name: "CaptureDetail",
        path: "/capture/:id",
        query: [
            "tab"
        ]
    }
];
function interpolate(template, params) {
    return template.replace(/:([A-Za-z][A-Za-z0-9]*)/g, (_all, name)=>{
        const value = params[name];
        if (value === undefined) {
            throw new Error("app-routes: missing param \"" + name + "\" for " + template);
        }
        return encodeURIComponent(value);
    });
}
/** Build a path from a catalog id and its `:param` values. */ export function pathFor(id, params = {}) {
    const route = ROUTES.find((entry)=>entry.id === id);
    if (!route) throw new Error("app-routes: unknown route \"" + id + "\"");
    return interpolate(route.path, params);
}
/** Typed builder for /delivery/programs/:programId/docs. */ export function programDocs(programId, opts = {}) {
    const pathname = interpolate("/delivery/programs/:programId/docs", {
        programId
    });
    const query = new URLSearchParams();
    if (opts.tab) query.set("tab", opts.tab);
    if (opts.set) query.set("set", opts.set);
    if (opts.item) query.set("item", opts.item);
    if (opts.doc) query.set("doc", opts.doc);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Typed builder for /delivery/programs/:programId/companies. */ export function programCompanies(programId, opts = {}) {
    const pathname = interpolate("/delivery/programs/:programId/companies", {
        programId
    });
    const query = new URLSearchParams();
    if (opts.company) query.set("company", opts.company);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Typed builder for /delivery/programs/:programId/deliverables. */ export function programDeliverables(programId, opts = {}) {
    const pathname = interpolate("/delivery/programs/:programId/deliverables", {
        programId
    });
    const query = new URLSearchParams();
    if (opts.occ) query.set("occ", opts.occ);
    if (opts.submit) query.set("submit", opts.submit);
    if (opts.review) query.set("review", opts.review);
    if (opts.assign) query.set("assign", opts.assign);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Typed builder for /delivery/programs/:programId/workstreams/:wsId. */ export function programTeam(programId, wsId, opts = {}) {
    const pathname = interpolate("/delivery/programs/:programId/workstreams/:wsId", {
        programId,
        wsId
    });
    const query = new URLSearchParams();
    if (opts.tab) query.set("tab", opts.tab);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Typed builder for /registries. */ export function registries(opts = {}) {
    const pathname = interpolate("/registries", {});
    const query = new URLSearchParams();
    if (opts.tab) query.set("tab", opts.tab);
    if (opts.record) query.set("record", opts.record);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Typed builder for /settings. */ export function settings(opts = {}) {
    const pathname = interpolate("/settings", {});
    const query = new URLSearchParams();
    if (opts.section) query.set("section", opts.section);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Typed builder for /capture/:id. */ export function captureDetail(id, opts = {}) {
    const pathname = interpolate("/capture/:id", {
        id
    });
    const query = new URLSearchParams();
    if (opts.tab) query.set("tab", opts.tab);
    const search = query.toString();
    return search ? pathname + "?" + search : pathname;
}
/** Home: Open the signed-in home dashboard. */ export function dashboard() {
    return "/dashboard";
}
/** Growth home: Open the Growth-only landing page. */ export function growthHome() {
    return "/growth/home";
}
/** RFI responses: Open the Growth list of RFI-response workspaces. */ export function growthRfiResponses() {
    return "/growth/rfi-responses";
}
/** Proposals: Open the Growth list of proposal workspaces. */ export function growthProposals() {
    return "/growth/proposals";
}
/** Assistant: Open the assist chat landing. */ export function assistant() {
    return "/assistant";
}
/** Assistant conversation: Open one assist conversation. */ export function assistantConversation(id) {
    return interpolate("/assistant/:id", {
        id
    });
}
/** Artifact Studio: Open the project-scoped generate/edit/approve studio. */ export function artifactStudio(projectId) {
    return interpolate("/artifact-studio/:projectId", {
        projectId
    });
}
/** OCI workspace: Open the OCI workspace for a project. */ export function oci(projectId) {
    return interpolate("/oci/:projectId", {
        projectId
    });
}
/** Protest workspace: Open the protest workspace for a project. */ export function protest(projectId) {
    return interpolate("/protest/:projectId", {
        projectId
    });
}
/** SSO configuration: Open the standalone SSO configuration page. */ export function ssoConfig() {
    return "/sso-config";
}
/** Authorization policies: Open the standalone authorization-policy page. */ export function policyConfig() {
    return "/policy-config";
}
/** Opportunities: Open the opportunities list. */ export function opportunities() {
    return "/opportunities";
}
/** Tracking Profiles: Open saved opportunity tracking profiles. */ export function trackingProfiles() {
    return "/opportunities/tracking-profiles";
}
/** Create tracking profile: Open the create-tracking-profile form. */ export function trackingProfilesCreate() {
    return "/opportunities/tracking-profiles/create";
}
/** Tracking profile: Open one tracking profile and its matches. */ export function trackingProfilesDetail(id) {
    return interpolate("/opportunities/tracking-profiles/:id", {
        id
    });
}
/** Edit tracking profile: Edit one tracking profile's criteria. */ export function trackingProfilesEdit(id) {
    return interpolate("/opportunities/tracking-profiles/:id/edit", {
        id
    });
}
/** Landscapes: Open the landscapes list. */ export function landscapes() {
    return "/landscapes";
}
/** New landscape: Create a landscape. */ export function landscapesNew() {
    return "/landscapes/new";
}
/** Landscape: Open one landscape. */ export function landscapesDetail(id) {
    return interpolate("/landscapes/:id", {
        id
    });
}
/** Landscape · seat history: Open one landscape's seat history. */ export function landscapesSeats(id) {
    return interpolate("/landscapes/:id/seats", {
        id
    });
}
/** Edit landscape: Edit one landscape. */ export function landscapesEdit(id) {
    return interpolate("/landscapes/:id/edit", {
        id
    });
}
/** Review briefs: Generate and browse a landscape's point-in-time review briefs. */ export function landscapesReports(id) {
    return interpolate("/landscapes/:id/briefs", {
        id
    });
}
/** Review brief: Open one frozen landscape review brief version. */ export function landscapesReportsDetail(id, reportId) {
    return interpolate("/landscapes/:id/briefs/:reportId", {
        id,
        reportId
    });
}
/** Pursuits: Open the pursuits list. */ export function capture() {
    return "/capture";
}
/** Pursuit · Customer & touchpoints: Open a pursuit's Customer & touchpoints section (touchpoints and people). */ export function captureCustomer(id) {
    return interpolate("/capture/:id/customer", {
        id
    });
}
/** Pursuit · Customer themes: Open a pursuit's customer themes. */ export function captureCustomerThemes(id) {
    return interpolate("/capture/:id/customer/themes", {
        id
    });
}
/** Pursuit · Competitors: Open a pursuit's competitive field. */ export function captureCompetitors(id) {
    return interpolate("/capture/:id/competitors", {
        id
    });
}
/** Pursuit · Black hat: Open a pursuit's black hat. */ export function captureBlackHat(id) {
    return interpolate("/capture/:id/black-hat", {
        id
    });
}
/** Pursuit · Win themes: Open a pursuit's win themes. */ export function captureWinThemes(id) {
    return interpolate("/capture/:id/win-themes", {
        id
    });
}
/** Pursuit · Teaming: Open a pursuit's teaming links, candidates and agreements. */ export function captureTeaming(id) {
    return interpolate("/capture/:id/teaming", {
        id
    });
}
/** Pursuit · RFI responses: Open a pursuit's RFI response workspaces. */ export function captureRfiResponses(id) {
    return interpolate("/capture/:id/rfi-responses", {
        id
    });
}
/** Pursuit · Proposal: Open the proposals opened from a pursuit. */ export function captureProposal(id) {
    return interpolate("/capture/:id/proposal", {
        id
    });
}
/** Pursuit · Go / no-go: Open a pursuit's gates, go/no-go decisions and lifecycle. */ export function captureDecisions(id) {
    return interpolate("/capture/:id/decisions", {
        id
    });
}
/** Pursuit · Splits & merges: Open a pursuit's splits and merges. */ export function captureSurgery(id) {
    return interpolate("/capture/:id/surgery", {
        id
    });
}
/** Pursuit · Docs: Open a pursuit's documents section. */ export function captureDocumentsSection(id) {
    return interpolate("/capture/:id/documents", {
        id
    });
}
/** Pursuit · Profile & plan: Open a pursuit's hypothesis, profile, team and action plan. */ export function capturePlan(id) {
    return interpolate("/capture/:id/plan", {
        id
    });
}
/** Pursuit · Solution: Open a pursuit's solution section. */ export function captureSolutionSection(id) {
    return interpolate("/capture/:id/solution", {
        id
    });
}
/** Pursuit · Outputs: Open a pursuit's outputs section. */ export function captureOutputsSection(id) {
    return interpolate("/capture/:id/outputs", {
        id
    });
}
/** Pursuit · Past performance: Open a pursuit's past performance section. */ export function capturePastPerformanceSection(id) {
    return interpolate("/capture/:id/past-performance", {
        id
    });
}
/** Pursuit · Workstreams: Open a pursuit's workstreams section. */ export function captureWorkstreamsSection(id) {
    return interpolate("/capture/:id/workstreams", {
        id
    });
}
/** Pursuit · Knowledge graph: Open the knowledge graph from a pursuit. */ export function captureGraph(id) {
    return interpolate("/capture/:id/graph", {
        id
    });
}
/** Pursuit · Chat: Open a pursuit's chat. */ export function captureChat(id) {
    return interpolate("/capture/:id/chat", {
        id
    });
}
/** RFI response: Open an RFI response workspace. */ export function rfiResponse(id) {
    return interpolate("/rfi-response/:id", {
        id
    });
}
/** RFI response · Response document: Open an RFI's response document at the top. */ export function rfiResponseDocument(id) {
    return interpolate("/rfi-response/:id/document", {
        id
    });
}
/** RFI response · Questions: Open an RFI's first question in the response document. */ export function rfiResponseQuestions(id) {
    return interpolate("/rfi-response/:id/questions", {
        id
    });
}
/** RFI response · Question: Open the RFI response document at one question's heading (sectionId = rfi_response_sections.id). */ export function rfiResponseQuestionsQuestion(id, sectionId) {
    return interpolate("/rfi-response/:id/questions/:sectionId", {
        id,
        sectionId
    });
}
/** RFI response · Capability statement: Open an RFI's capability statement. */ export function rfiResponseCapabilityStatement(id) {
    return interpolate("/rfi-response/:id/capability-statement", {
        id
    });
}
/** RFI response · Reviews: Open an RFI's reviews. */ export function rfiResponseReviews(id) {
    return interpolate("/rfi-response/:id/reviews", {
        id
    });
}
/** RFI response · Chat history: Open an RFI's chat history. */ export function rfiResponseChat(id) {
    return interpolate("/rfi-response/:id/chat", {
        id
    });
}
/** RFI response · Notice and attachments: Open an RFI's notice and attachments. */ export function rfiResponseNotice(id) {
    return interpolate("/rfi-response/:id/notice", {
        id
    });
}
/** RFI response · Labor categories: Open an RFI's labor categories. */ export function rfiResponseLaborCategories(id) {
    return interpolate("/rfi-response/:id/labor-categories", {
        id
    });
}
/** RFI response · Q&A and amendments: Open an RFI's Q&A and amendments. */ export function rfiResponseAmendments(id) {
    return interpolate("/rfi-response/:id/amendments", {
        id
    });
}
/** RFI response · Past answers: Open past answers relevant to an RFI. */ export function rfiResponsePastAnswers(id) {
    return interpolate("/rfi-response/:id/past-answers", {
        id
    });
}
/** RFI response · Team: Open an RFI's team. */ export function rfiResponseTeam(id) {
    return interpolate("/rfi-response/:id/team", {
        id
    });
}
/** RFI response · Per-question editor: Open the legacy per-question RFI workspace. */ export function rfiResponseLegacy(id) {
    return interpolate("/rfi-response/:id/legacy", {
        id
    });
}
/** Pricing sheet review: Review one staged pricing sheet. */ export function registriesPricingSheetReview(changeSetId) {
    return interpolate("/registries/pricing-sheets/:changeSetId", {
        changeSetId
    });
}
/** Contact: Open one person's full registry record (flag registries_records_v1; off opens the drawer). */ export function registriesContact(id) {
    return interpolate("/registries/contacts/:id", {
        id
    });
}
/** Company: Open one company's full registry record (flag registries_records_v1; off opens the drawer). */ export function registriesCompany(id) {
    return interpolate("/registries/companies/:id", {
        id
    });
}
/** Labor category: Open one labor category anchor across companies (flag registries_records_v1). */ export function registriesLcatAnchor(anchorId) {
    return interpolate("/registries/labor-categories/:anchorId", {
        anchorId
    });
}
/** Labor category entry: Open one company's labor category entry as a full page (flag registries_records_v1). */ export function registriesLcatEntry(entryId) {
    return interpolate("/registries/labor-categories/entries/:entryId", {
        entryId
    });
}
/** Contract vehicle: Open one contract vehicle's full registry record (flag registries_records_v1). */ export function registriesVehicle(id) {
    return interpolate("/registries/vehicles/:id", {
        id
    });
}
/** Government org: Open one government organization's full registry record (flag registries_records_v1). */ export function registriesGovorg(id) {
    return interpolate("/registries/gov-orgs/:id", {
        id
    });
}
/** Review queue: Open the unified registry review queue (flag registries_records_v1). */ export function registriesReviewQueue() {
    return "/registries/review-queue";
}
/** People movement: Open people movement: org charts over time and moves between organizations (flags registries_records_v1 + people_movement_v1). */ export function registriesPeopleMovement() {
    return "/registries/people-movement";
}
/** Delivery: Open the delivery hub. */ export function delivery() {
    return "/delivery";
}
/** Command Center: Open the cross-project delivery command center. */ export function deliveryCommandCenter() {
    return "/delivery/command-center";
}
/** Command Center · Deliverables: Open the command-center deliverables drill-down. */ export function deliveryCommandCenterDeliverables() {
    return "/delivery/command-center/deliverables";
}
/** Organization: Open the delivery organization view. */ export function deliveryOrg() {
    return "/delivery/org";
}
/** Proof & Evidence Board: Open the cross-portfolio evidence board. */ export function deliveryEvidenceBoard() {
    return "/delivery/evidence-board";
}
/** Delivery Calendar: Open the cross-project delivery calendar. */ export function deliveryCalendar() {
    return "/delivery/calendar";
}
/** Programs: Open the programs list. */ export function deliveryPrograms() {
    return "/delivery/programs";
}
/** Audit templates: Open delivery audit templates. */ export function deliveryAuditTemplates() {
    return "/delivery/audit-templates";
}
/** Pre-award workspace: Open the pre-award V2 cockpit. */ export function deliveryPreAward(id) {
    return interpolate("/delivery/pre-award/:id/v2", {
        id
    });
}
/** Award comparison: Open an award-comparison workspace. */ export function deliveryAwardComparison(id, csId) {
    return interpolate("/delivery/pre-award/:id/comparison/:csId", {
        id,
        csId
    });
}
/** Program home: Open a program's home. */ export function programHome(programId) {
    return interpolate("/delivery/programs/:programId", {
        programId
    });
}
/** Activation Gate: Open a converted program's activation gate. */ export function programActivationGate(programId) {
    return interpolate("/delivery/programs/:programId/activation-gate", {
        programId
    });
}
/** Closeout: Open a program's closeout page. */ export function programCloseout(programId) {
    return interpolate("/delivery/programs/:programId/closeout", {
        programId
    });
}
/** Workroom: Open a program's workroom. */ export function programWorkroom(programId) {
    return interpolate("/delivery/programs/:programId/workroom", {
        programId
    });
}
/** Roles: Open a program's roles page. */ export function programRoles(programId) {
    return interpolate("/delivery/programs/:programId/roles", {
        programId
    });
}
/** Contacts: Open a program's contacts page. */ export function programContacts(programId) {
    return interpolate("/delivery/programs/:programId/contacts", {
        programId
    });
}
/** CLINs: Open a program's CLIN table. */ export function programClins(programId) {
    return interpolate("/delivery/programs/:programId/clins", {
        programId
    });
}
/** Teams: Open a program's teams index. */ export function programTeams(programId) {
    return interpolate("/delivery/programs/:programId/workstreams", {
        programId
    });
}
/** Capabilities: Open a program's capabilities page. */ export function programCapabilities(programId) {
    return interpolate("/delivery/programs/:programId/capabilities", {
        programId
    });
}
/** Deliverable: Open one deliverable (duty) page. */ export function programDeliverable(programId, dutyId) {
    return interpolate("/delivery/programs/:programId/deliverables/:dutyId", {
        programId,
        dutyId
    });
}
/** Beyond Scope: Open work beyond the award. */ export function programBeyondScope(programId) {
    return interpolate("/delivery/programs/:programId/beyond-scope", {
        programId
    });
}
/** Weekly Recap: Open a program's weekly recap. */ export function programWeeklyRecap(programId) {
    return interpolate("/delivery/programs/:programId/weekly-recap", {
        programId
    });
}
/** Optional Tasks: Open a program's optional tasks. */ export function programOptionalTasks(programId) {
    return interpolate("/delivery/programs/:programId/optional-tasks", {
        programId
    });
}
/** Places: Open a program's places page. */ export function programPlaces(programId) {
    return interpolate("/delivery/programs/:programId/places", {
        programId
    });
}
/** Glossary: Open a program's glossary. */ export function programGlossary(programId) {
    return interpolate("/delivery/programs/:programId/glossary", {
        programId
    });
}
/** Periods: Open a program's periods of performance. */ export function programPeriods(programId) {
    return interpolate("/delivery/programs/:programId/periods", {
        programId
    });
}
/** Program settings: Open a program's deliverable settings. */ export function programSettings(programId) {
    return interpolate("/delivery/programs/:programId/settings", {
        programId
    });
}
/** Audits: Open a program's audits page. */ export function programAudits(programId) {
    return interpolate("/delivery/programs/:programId/audits", {
        programId
    });
}
/** Waivers and Tailoring: Open waivers and tailoring. */ export function programWaiversTailoring(programId) {
    return interpolate("/delivery/programs/:programId/waivers-tailoring", {
        programId
    });
}
/** Quality: Open a program's quality page. */ export function programQuality(programId) {
    return interpolate("/delivery/programs/:programId/quality", {
        programId
    });
}
/** Potential Issues: Open potential issues (risks tab by default). */ export function programPotentialIssues(programId) {
    return interpolate("/delivery/programs/:programId/potential-issues", {
        programId
    });
}
/** Potential Issues · Risks: Open the risks sub-tab. */ export function programPotentialIssuesRisks(programId) {
    return interpolate("/delivery/programs/:programId/potential-issues?tab=risks", {
        programId
    });
}
/** Potential Issues · Issues: Open the issues sub-tab. */ export function programPotentialIssuesIssues(programId) {
    return interpolate("/delivery/programs/:programId/potential-issues?tab=issues", {
        programId
    });
}
/** Potential Issues · Sub reviews: Open the subcontractor-reviews sub-tab. */ export function programPotentialIssuesSubReviews(programId) {
    return interpolate("/delivery/programs/:programId/potential-issues?tab=sub-reviews", {
        programId
    });
}
/** History: Open a program's operations history (ops-audit). */ export function programHistory(programId) {
    return interpolate("/delivery/programs/:programId/ops-audit", {
        programId
    });
}
/** Touchpoints: Open a program's growth touchpoints. */ export function programTouchpoints(programId) {
    return interpolate("/delivery/programs/:programId/touchpoints", {
        programId
    });
}
/** Financial: Open financial health when at least one figure is unmasked. */ export function programFinancial(programId) {
    return interpolate("/delivery/programs/:programId/financial", {
        programId
    });
}
/** Documents: Open the global documents library. */ export function documents() {
    return "/documents";
}
/** Upload document: Open the global document upload page. */ export function documentsUpload() {
    return "/documents/upload";
}
/** Editor: Open the collaborative editor list. */ export function editor() {
    return "/editor";
}
/** Editor folder: Open one editor folder. */ export function editorFolder(folderId) {
    return interpolate("/editor/folder/:folderId", {
        folderId
    });
}
/** Editor document: Open one collaborative document. */ export function editorDocument(documentId) {
    return interpolate("/editor/:documentId", {
        documentId
    });
}
/** SharePoint documents: Open the SharePoint documents browser. */ export function sharepointDocuments() {
    return "/sharepoint-documents";
}
/** Projects: Open the projects list. */ export function projects() {
    return "/projects";
}
/** Create project: Open the create-project wizard. */ export function projectsCreate() {
    return "/projects/create";
}
/** Project: Open a general project's overview. */ export function projectOverview(projectId) {
    return interpolate("/project/:projectId", {
        projectId
    });
}
/** Project chat: Open a project's chat list. */ export function projectChat(projectId) {
    return interpolate("/project/:projectId/chat", {
        projectId
    });
}
/** Project conversation: Open one project conversation. */ export function projectChatConversation(projectId, chatId) {
    return interpolate("/project/:projectId/chat/:chatId", {
        projectId,
        chatId
    });
}
/** Project documents: Open a project's documents. */ export function projectDocuments(projectId) {
    return interpolate("/project/:projectId/documents", {
        projectId
    });
}
/** Project team: Open a project's team page. */ export function projectTeam(projectId) {
    return interpolate("/project/:projectId/team", {
        projectId
    });
}
/** Project settings: Open a project's settings. */ export function projectSettings(projectId) {
    return interpolate("/project/:projectId/settings", {
        projectId
    });
}
/** Project opportunities: Open opportunities while staying in a project. */ export function projectOpportunities(projectId) {
    return interpolate("/project/:projectId/opportunities", {
        projectId
    });
}
/** Project SharePoint: Open SharePoint documents in project context. */ export function projectSharepoint(projectId) {
    return interpolate("/project/:projectId/sharepoint", {
        projectId
    });
}
/** Project history: Open history in project context. */ export function projectHistory(projectId) {
    return interpolate("/project/:projectId/history", {
        projectId
    });
}
/** Proposal: Open a proposal dashboard. */ export function proposal(id) {
    return interpolate("/proposal/:id", {
        id
    });
}
/** Proposal settings: Open a proposal's settings. */ export function proposalSettings(id) {
    return interpolate("/proposal/:id/settings", {
        id
    });
}
/** Proposal V2 · Home: Open the V2 proposal home. */ export function proposalV2Home(id) {
    return interpolate("/proposal/:id/v2/home", {
        id
    });
}
/** Proposal V2 · Compliance: Open the V2 compliance hub. */ export function proposalV2Compliance(id) {
    return interpolate("/proposal/:id/v2/compliance", {
        id
    });
}
/** Proposal V2 · Capability matrix: Open the V2 capability matrix. */ export function proposalV2CapabilityMatrix(id) {
    return interpolate("/proposal/:id/v2/capability-matrix", {
        id
    });
}
/** Proposal V2 · Reviews: Open the V2 reviews list. */ export function proposalV2Reviews(id) {
    return interpolate("/proposal/:id/v2/reviews", {
        id
    });
}
/** Proposal V2 · Review: Open one V2 proposal review. */ export function proposalV2Review(id, reviewId) {
    return interpolate("/proposal/:id/v2/reviews/:reviewId", {
        id,
        reviewId
    });
}
/** Proposal V2 · Chat history: Open the V2 proposal chat history. */ export function proposalV2ChatHistory(id) {
    return interpolate("/proposal/:id/v2/chat-history", {
        id
    });
}
/** Proposal V2 · Volume: Open one proposal volume workspace. */ export function proposalV2Volume(id, volumeId) {
    return interpolate("/proposal/:id/v2/volume/:volumeId", {
        id,
        volumeId
    });
}
/** Proposal V2 · Volume section: Open one section inside a proposal volume. */ export function proposalV2VolumeSection(id, volumeId, sectionId) {
    return interpolate("/proposal/:id/v2/volume/:volumeId/section/:sectionId", {
        id,
        volumeId,
        sectionId
    });
}
/** Proposal V2 · Source files: Open V2 source files. */ export function proposalV2SourcesFiles(id) {
    return interpolate("/proposal/:id/v2/sources/files", {
        id
    });
}
/** Proposal V2 · Source CLINs: Open V2 source CLINs. */ export function proposalV2SourcesClins(id) {
    return interpolate("/proposal/:id/v2/sources/clins", {
        id
    });
}
/** Proposal V2 · Source LCATs: Open V2 source labor categories. */ export function proposalV2SourcesLcats(id) {
    return interpolate("/proposal/:id/v2/sources/lcats", {
        id
    });
}
/** Proposal V2 · Source pricing: Open V2 source pricing. */ export function proposalV2SourcesPricing(id) {
    return interpolate("/proposal/:id/v2/sources/pricing", {
        id
    });
}
/** Proposal V2 · From the pursuit: Open what the proposal carried in from its pursuit. */ export function proposalV2SourcesPursuit(id) {
    return interpolate("/proposal/:id/v2/sources/pursuit", {
        id
    });
}
/** Proposal V2 · Source team: Open V2 source team. */ export function proposalV2SourcesTeam(id) {
    return interpolate("/proposal/:id/v2/sources/team", {
        id
    });
}
/** Proposal V2 · Source history: Open V2 source history. */ export function proposalV2SourcesHistory(id) {
    return interpolate("/proposal/:id/v2/sources/history", {
        id
    });
}
/** Access requests: Open the designated-grantor request queue. */ export function requests() {
    return "/requests";
}
/** Admin · People: Open the admin people directory. */ export function adminPeople() {
    return "/admin/people";
}
/** Admin · Groups: Open admin groups. */ export function adminGroups() {
    return "/admin/groups";
}
/** Admin · Permissions: Open admin permissions. */ export function adminPermissions() {
    return "/admin/permissions";
}
/** Admin · Access rules: Open admin access rules (who can see or do each sensitive thing). */ export function adminAccessRules() {
    return "/admin/access-rules";
}
/** Admin · Activity: Open the admin activity log. */ export function adminActivity() {
    return "/admin/activity";
}
/** Admin · Notifications: Open company notification defaults and the delivery log. */ export function adminNotifications() {
    return "/admin/notifications";
}
/** Admin · Access: Open access administration (server reviewer flag; self-service for others). */ export function adminAccess() {
    return "/admin/access";
}
/** Admin · Usage: Open admin usage. */ export function adminUsage() {
    return "/admin/usage";
}
/** Help: Open help. */ export function help() {
    return "/help";
}
/** History: Open the global history page. */ export function history() {
    return "/history";
}
/** Library: Open the library. */ export function library() {
    return "/library";
}
/** Vault: Open the vault. */ export function vault() {
    return "/vault";
}
export const appLinks = {
    programDocs,
    programCompanies,
    programDeliverables,
    programTeam,
    registries,
    settings,
    captureDetail,
    dashboard,
    growthHome,
    growthRfiResponses,
    growthProposals,
    assistant,
    assistantConversation,
    artifactStudio,
    oci,
    protest,
    ssoConfig,
    policyConfig,
    opportunities,
    trackingProfiles,
    trackingProfilesCreate,
    trackingProfilesDetail,
    trackingProfilesEdit,
    landscapes,
    landscapesNew,
    landscapesDetail,
    landscapesSeats,
    landscapesEdit,
    landscapesReports,
    landscapesReportsDetail,
    capture,
    captureCustomer,
    captureCustomerThemes,
    captureCompetitors,
    captureBlackHat,
    captureWinThemes,
    captureTeaming,
    captureRfiResponses,
    captureProposal,
    captureDecisions,
    captureSurgery,
    captureDocumentsSection,
    capturePlan,
    captureSolutionSection,
    captureOutputsSection,
    capturePastPerformanceSection,
    captureWorkstreamsSection,
    captureGraph,
    captureChat,
    rfiResponse,
    rfiResponseDocument,
    rfiResponseQuestions,
    rfiResponseQuestionsQuestion,
    rfiResponseCapabilityStatement,
    rfiResponseReviews,
    rfiResponseChat,
    rfiResponseNotice,
    rfiResponseLaborCategories,
    rfiResponseAmendments,
    rfiResponsePastAnswers,
    rfiResponseTeam,
    rfiResponseLegacy,
    registriesPricingSheetReview,
    registriesContact,
    registriesCompany,
    registriesLcatAnchor,
    registriesLcatEntry,
    registriesVehicle,
    registriesGovorg,
    registriesReviewQueue,
    registriesPeopleMovement,
    delivery,
    deliveryCommandCenter,
    deliveryCommandCenterDeliverables,
    deliveryOrg,
    deliveryEvidenceBoard,
    deliveryCalendar,
    deliveryPrograms,
    deliveryAuditTemplates,
    deliveryPreAward,
    deliveryAwardComparison,
    programHome,
    programActivationGate,
    programCloseout,
    programWorkroom,
    programRoles,
    programContacts,
    programClins,
    programTeams,
    programCapabilities,
    programDeliverable,
    programBeyondScope,
    programWeeklyRecap,
    programOptionalTasks,
    programPlaces,
    programGlossary,
    programPeriods,
    programSettings,
    programAudits,
    programWaiversTailoring,
    programQuality,
    programPotentialIssues,
    programPotentialIssuesRisks,
    programPotentialIssuesIssues,
    programPotentialIssuesSubReviews,
    programHistory,
    programTouchpoints,
    programFinancial,
    documents,
    documentsUpload,
    editor,
    editorFolder,
    editorDocument,
    sharepointDocuments,
    projects,
    projectsCreate,
    projectOverview,
    projectChat,
    projectChatConversation,
    projectDocuments,
    projectTeam,
    projectSettings,
    projectOpportunities,
    projectSharepoint,
    projectHistory,
    proposal,
    proposalSettings,
    proposalV2Home,
    proposalV2Compliance,
    proposalV2CapabilityMatrix,
    proposalV2Reviews,
    proposalV2Review,
    proposalV2ChatHistory,
    proposalV2Volume,
    proposalV2VolumeSection,
    proposalV2SourcesFiles,
    proposalV2SourcesClins,
    proposalV2SourcesLcats,
    proposalV2SourcesPricing,
    proposalV2SourcesPursuit,
    proposalV2SourcesTeam,
    proposalV2SourcesHistory,
    requests,
    adminPeople,
    adminGroups,
    adminPermissions,
    adminAccessRules,
    adminActivity,
    adminNotifications,
    adminAccess,
    adminUsage,
    help,
    history,
    library,
    vault
};
